export default "__VITE_ASSET__Ci27kHJN__"